var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMsg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5656 0.175119C15.8813 0.393869 16.0469 0.771994 15.9875 1.15012L13.9875 14.1501C13.9406 14.4532 13.7563 14.7189 13.4875 14.8689C13.2188 15.0189 12.8969 15.0376 12.6125 14.9189L8.87502 13.3657L6.7344 15.6814C6.45627 15.9845 6.01877 16.0845 5.6344 15.9345C5.25002 15.7845 5.00002 15.4126 5.00002 15.0001V12.3876C5.00002 12.2626 5.0469 12.1439 5.13127 12.0532L10.3688 6.33762C10.55 6.14074 10.5438 5.83762 10.3563 5.65012C10.1688 5.46262 9.86564 5.45012 9.66877 5.62824L3.31252 11.2751L0.553145 9.89387C0.221895 9.72824 0.00939531 9.39699 2.031e-05 9.02824C-0.00935469 8.65949 0.184395 8.31574 0.503145 8.13137L14.5031 0.131369C14.8375 -0.0592555 15.25 -0.0405055 15.5656 0.175119Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsg);
export default __webpack_public_path__ + "static/media/msg.a8ae76c32b4a30d4868ea19b47f81105.svg";
export { ForwardRef as ReactComponent };